import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      lotteryid: 0,
      selectTab: 0
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/luckylottery/items", {
        lottery_id: this.lotteryid,
        status: this.selectTab == 0 ? 1 : 0
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
        this.list.map(item => {
          if (item.gift_id > 0) item.gift_extra = JSON.parse(item.gift_extra);
          return item;
        });
      }
    },
    async onCreate() {
      this.modifyData = {
        "lottery_type": "0",
        "lottery_id": this.lotteryid,
        "icon": "",
        'currency': "TAPCOINS",
        "status": "1"
      };
      this.popTaskShow = true;
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onLogs(id) {
      this.$router.push("/luckylotterylogs?item_id=" + id);
    }
  },
  mounted() {
    this.lotteryid = this.$route.query.id || 0;
    if (!this.lotteryid) {
      this.$router.back();
    }
    this.getData();
  }
};